import React, { ReactElement } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Container, CloseIcon, NotificationContainer, NotificationContent } from './mixins'

const PopOver = ({ children, isOpen, onClose }) => {
  const icon = { name: 'icon-light-close' }
  const buttonOptions = { size: 'medium', type: 'link', variant: 'black' }

  return (
    <NotificationContainer>
      <NotificationContent>
        <Container isOpened={isOpen}>
          <CloseIcon icon={icon} buttonoptions={buttonOptions} onClick={onClose} />
          {children}
        </Container>
      </NotificationContent>
    </NotificationContainer>
  )
}

const Component = ({ onClose, isOpen, children }: { onClose: () => void; isOpen: boolean; children: ReactElement }) => {
  const portalElement = document.getElementById('floating-elements')

  const NotificationComponent = () => (
    <PopOver isOpen={isOpen} onClose={onClose}>
      {children}
    </PopOver>
  )

  return ReactDOM.createPortal(<NotificationComponent />, portalElement as HTMLElement)
}

export default Component

Component.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  children: PropTypes.element,
}

Component.defaultProps = {
  onClose: () => {},
  isOpen: false,
  children: <></>,
}
